import { Component } from "@angular/core";
import { PageLayout } from "@cvx/nextpage";
import { NumberOfMonths } from "src/app/models/charts/by-request-type/numberOfMonths.enum";
import { WorkflowRequestTypes } from "src/app/models/requests/enums/WorkflowRequestTypes.enum";


@Component({
    selector: 'dashboard-by-type',
    templateUrl: './dashboard-by-type.component.html'
})

export class DashboardByTypeComponent {
    PageLayout = PageLayout;

    readonly initialRequestType = WorkflowRequestTypes.ApplicationPermissionGrant;
    numberOfMonths: NumberOfMonths = NumberOfMonths.LastThreeMonths; // Default to last 3 months   
}